import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useProjects } from '../../context/ProjectContext';
import EngagementDashboard from '../Dashboard';

const ProjectDashboard = () => {
  const { projectId } = useParams();
  const { projects } = useProjects();
  const project = projects.find(item => String(item.id) === String(projectId));

  return (
    <Container className="py-4">
      <EngagementDashboard projectId={projectId} />
    </Container>
  );
};

export default ProjectDashboard;
